import { Reducer } from "redux";

import { AuthOrderingPhysicianDetailsResponse } from "../models/Api/PhysicianDetails";
import { AuthOrderingPhysicianDetailsDispatchTypes } from "../models/DispatchTypes/PhysicianDetails";
import {
  AuthOrderingPhysicianDetailsActionDispatchType,
  PhysicianTypeID,
} from "../constants/PhysicianDetails";
import { get404InitialData, mergeObjects } from "../utils";

const initialState: AuthOrderingPhysicianDetailsResponse = {
  loading: true,
  response: {
    referralId: 0,
    referralPhysicianDetailId: 0,
    physicianId: 0,
    physicianName: "",
    physicianNpiId: "",
    physicianAddress: "",
    phoneNo: "",
    phoneExt: "",
    taxId: "",
    fax: "",
    streetName1: "",
    streetName2: "",
    city: "",
    physicianState: "",
    zipCode: "",
    userCreated: null,
    userUpdated: "",
    physicianTypeId: PhysicianTypeID.DEFAULT,
  },
};

const AuthOrderingPhysicianDetailsReducer: Reducer<
  AuthOrderingPhysicianDetailsResponse,
  AuthOrderingPhysicianDetailsDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case AuthOrderingPhysicianDetailsActionDispatchType.GET_ORDERING_PHYSICIAN_DETAILS_INVOKE: {
      return mergeObjects(state, { loading: true });
    }
    case AuthOrderingPhysicianDetailsActionDispatchType.GET_ORDERING_PHYSICIAN_DETAILS_SUCCESS: {
      return mergeObjects(state, {
        response: get404InitialData(action.response, initialState),
        loading: false,
      });
    }
    case AuthOrderingPhysicianDetailsActionDispatchType.PUT_ORDERING_PHYSICIAN_DETAILS_INVOKE: {
      return mergeObjects(state, { loading: true });
    }
    case AuthOrderingPhysicianDetailsActionDispatchType.PUT_ORDERING_PHYSICIAN_DETAILS_SUCCESS: {
      return mergeObjects(state, { response: action.response, loading: false });
    }
    case AuthOrderingPhysicianDetailsActionDispatchType.PUT_ORDERING_PHYSICIAN_DETAILS_ERROR: {
      return mergeObjects(state, { error: action.response, loading: false });
    }
    case AuthOrderingPhysicianDetailsActionDispatchType.GET_ORDERING_PHYSICIAN_DETAILS_RESET: {
      return initialState;
    }
  }
  return state;
};

export default AuthOrderingPhysicianDetailsReducer;
